/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Windows_S4Inputs */

const en_fc_dl_windows_s4 = /** @type {(inputs: Fc_Dl_Windows_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start FilmCraft from the Start menu.`)
};

/**
* | output |
* | --- |
* | "Start FilmCraft from the Start menu." |
*
* @param {Fc_Dl_Windows_S4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_windows_s4 = /** @type {((inputs?: Fc_Dl_Windows_S4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Windows_S4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_windows_s4(inputs)
});
export { fc_dl_windows_s4 as "fc.dl.windows.s4" }